import EventEmitter from '@src/../node_modules/events'

export const entityChangementEE = new EventEmitter()
